import { useTrackReviewInteraction } from '@components/reviews/components/search-sort-filter/hooks/use-track-review-interaction';
import { useEscape } from '@hooks/useEscape';
import { useAppSelector } from '@redux/hooks';
import { selectIsMobile } from '@redux/viewport/selectors';
import { useOutsideClickEffect } from '@xo-union/ui-accessibility';
import { useAtomValue } from 'jotai';
import React, { useRef, useState } from 'react';
import {
	areStarRatingsSavedAtom,
	currentStarRatingsAtom,
	previousStarRatingsAtom,
} from '../../atoms';
import { BaseFilterPill } from '../base-filter-pill';
import { RatingsModal } from './ratings-modal';
import { Body } from './ratings-modal/body';
import Styles from './styles.scss';

const RatingsFilterPill = () => {
	const containerRef = useRef<HTMLDivElement>(null);
	const isMobile = useAppSelector((state) => selectIsMobile(state));
	const [isRatingMenuOpen, setIsRatingMenuOpen] = useState(false);
	const areStarRatingsSaved = useAtomValue(areStarRatingsSavedAtom);
	const currentStarRatings = useAtomValue(currentStarRatingsAtom);
	const previousStarRatings = useAtomValue(previousStarRatingsAtom);

	const numberOfAppliedStarRatings = areStarRatingsSaved
		? currentStarRatings.length
		: previousStarRatings.length;

	const label =
		numberOfAppliedStarRatings > 0
			? `Filter by rating (${numberOfAppliedStarRatings})`
			: 'Filter by rating';

	const hasSelectedFilters = numberOfAppliedStarRatings > 0;

	const trackReviewInteraction = useTrackReviewInteraction();
	const handleClick = () => {
		if (!isRatingMenuOpen) {
			trackReviewInteraction({
				action: 'filter by rating initiated',
			});
		}
		setIsRatingMenuOpen((prevState) => !prevState);
	};

	const handleClose = () => {
		setIsRatingMenuOpen(false);
	};

	useEscape(handleClose);

	useOutsideClickEffect(
		{
			onClickOutside: isMobile
				? () => {
						/* noop */
					}
				: handleClose,
		},
		containerRef,
	);

	return (
		<BaseFilterPill
			label={label}
			onClick={handleClick}
			className={isRatingMenuOpen ? Styles.menuOpen : undefined}
			containerRef={containerRef}
			hasSelectedFilters={hasSelectedFilters}
		>
			{isRatingMenuOpen &&
				(isMobile ? (
					<RatingsModal
						isModalOpen={isRatingMenuOpen}
						handleClose={handleClose}
					/>
				) : (
					<Body isMobile={isMobile} handleClose={handleClose} />
				))}
		</BaseFilterPill>
	);
};

export { RatingsFilterPill };
